
import Vue from 'vue'

const axios = require("axios")
import config from '@/config'


function resetState(state) {
   Object.assign(state, {
      teams: {},
      user2teamList: {},
   })
}

const state = {}
resetState(state)

const mutations = {

   RESET_STATE (state) {
      //console.log('teams/RESET_STATE')
      resetState(state)
   },

   SET_USER_TEAMS (state, { userId, teams }) {
      if (!state.user2teamList.hasOwnProperty(userId)) Vue.set(state.user2teamList, userId, [])
      // add each team of teams to state.teams
      teams.forEach(function(team) {
         Vue.set(state.teams, team.id, team)
      })
      Vue.set(state.user2teamList, userId, teams.map(team => team.id))
   },
}

const actions = {

   GET_USER_TEAMS ({ commit, rootState }, userId) {
      return axios({
         method: 'get',
         url: `${config.TEAMS_URL}?user=${userId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let userTeamsDict = { userId: userId, teams: response.data }
         commit('SET_USER_TEAMS', userTeamsDict)
         return response.data
      })
   },
}

const getters = {

}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
}



// WEBPACK FOOTER //
// ./src/store/teams/index.js